<script setup>
import { useI18n } from "vue-i18n";
const { locale } = useI18n();
import MissionVisionComponent from "@/Components/Frontend/Home/MissionVisionComponent.vue";
defineProps(["hero_text", "mission_vision"]);
</script>
<template>
    <section class="text-gray-600">
        <div
            class="container 2xl:px-48 xl:px-16 lg:pt-32 sm:pt-20 pt-20 mx-auto"
        >
            <!-- class="container 2xl:px-56 xl:px-16 lg:pt-32 sm:pt-20 pt-20 mx-auto"
        > -->
            <div class="flex flex-wrap">
                <div
                    class="lg:w-1/2 min-w-full min-h-full md:mx-auto lg:pl-6 pt-4 bg-white lg:hidden block"
                >
                    <div class="text-justify">
                        <!-- <img src="/hero_banners/home-banner.webp" 
                            class="w-full h-full sm:block hidden"
                            alt="Hero Banner"> -->

                        <img src="/hero_banners/home-banner-mobile.webp" class="w-full aspect-[380/373] object-cover"
                            alt="Home Banner" 
                        decoding="async" />

                        <!-- <VLazyImage
                            :src="hero_text.image" 
                            alt="Banner Image"
                            class="sm:h-[300px] sm:w-[300px] object-cover"
                        /> -->
                    </div>
                </div>
    
                <div
                    class="lg:w-1/2 w-full lg:mb-0 lg:pr-12 sm:px-0 px-4 lg:mt-0 mt-4 sm:wow animate__animated animate__fadeInLeft"
                >
                    <div>
                        <!-- <h2
                            class="text-black font-medium 2xl:text-[42px] xl:text-[42px] lg:text-[36px] text-[24px] leading-tight uppercase"
                        >
                            <span class="text-[#0094A1] sm:text-[#1CBED1]">{{
                                locale === "BN"
                                    ? hero_text?.bn_heading
                                    : hero_text?.heading
                            }}</span>
                            {{
                                locale === "BN"
                                    ? hero_text?.bn_sub_heading
                                    : hero_text?.sub_heading
                            }}
                        </h2> -->
                        <h2
                            class="text-black font-semibold 2xl:text-[56px] xl:text-[52px] lg:text-[48px] text-[42px] leading-tight uppercase"
                        >
                            <span class="text-[#0094A1] sm:text-[#1CBED1]">{{
                                locale === "BN"
                                    ? hero_text?.bn_heading
                                    : hero_text?.heading
                            }}</span>
                            
                        </h2>
                        <h3
                            class="text-black font-semibold 2xl:text-[35px] xl:text-[33px] lg:text-[30px] text-[21px] leading-tight uppercase"
                        >
                            {{
                                locale === "BN"
                                    ? hero_text?.bn_sub_heading
                                    : hero_text?.sub_heading
                            }}
                        </h3>
                        <div class="flex flex-col md:flex-row">
                            <div class="text-justify">
                                <p
                                    class="sm:mt-8 mt-4 text-black sm:text-[18px] text-base leading-relaxed"
                                    v-html="
                                        locale === 'BN'
                                            ? hero_text?.bn_content
                                            : hero_text?.content
                                    "
                                ></p>
                            </div>
                        </div>
                    </div>

                    <mission-vision-component
                        :mission_vision="mission_vision"
                    />
                </div>
                <div
                    class="lg:w-1/2 2xl:min-h-[550px] xl:min-h-[580px] lg:min-h-[500px] md:w/2 md:mx-auto pt-4 bg-white hidden lg:block wow animate__animated animate__fadeInRight"
                >
                    <!-- <div class="xl:h-[500px] xl:w-[500px] lg:h-[450px] lg:w-[450px] text-justify">
                        <VLazyImage
                            :src="hero_text.image"
                            alt="Banner Image"
                            class="w-full h-full object-cover"
                        />
                    </div> -->
                        <img src="/hero_banners/home-banner.webp"
                            
                        alt="Home Banner" 
                        class="" 
                        decoding="async" />
                </div>
            </div>
        </div>
    </section>
</template>
<style scoped></style>
